const register = {
  loginCredentials: "אישורי כניסה", // translated
  companyInformation: "מידע על החברה", // translated
  contactDetails: "פרטי יצירת קשר", // translated
  businessName: "שם עסק", // translated
  businessAddress: "כתובת עסקית", // translated
  registrationCode: "קוד הרשמה", // translated
  businessRegistrationNumber: "מספר רישום עסק", // translated
  websiteUrl: "כתובת אתר", // translated
  mobilePhone: "טלפון נייד", // translated
  regionStateProvince: "אזור/מדינה/מחוז", // translated
  legalTitle: "כותרת משפטית", // translated
  city: "עִיר", // translated
  postalCode: "מיקוד", // translated
  registrationSuccess: "הרשמה מוצלחת.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "אנא המתן מספר רגעים ותועבר לדף הבית.", // translated
  usernameEmail: "שם משתמש (אימייל)", // translated
  password: "סיסמה", // translated
  verifyPassword: "אימות סיסמה", // translated
  documents: "מסמכים", // translated
  termsAndConditionsSection: "תנאים והגבלות", // translated
  certificateOfIncorporation: "תעודת התאגדות", // translated
  acceptTermsAndConditions: "קבלת תנאים והגבלות", // translated
  country: "מדינה", // translated
  brandName: "שם מותג", // translated
  register: "הרשמה", // translated
  isRequired: "נדרש", // translated
  passwordMin8Chars: "חייב להכיל לפחות 8 תווים", // translated
  passwordRequiresDigit: "חייב להכיל לפחות ספרה אחת", // translated
  passwordRequiresLowercase: "חייב להכיל לפחות אות קטנה אחת", // translated
  passwordRequiresUppercase: "חייב להכיל לפחות אות גדולה אחת", // translated
  passwordRequiresSpecialChar: 'חייב להכיל לפחות תו מיוחד אחד (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "העלאת קובץ", // translated
  filename: "שם קובץ:", // translated
  fileType: "סוג:", // translated
  fileSize: "גודל:", // translated
  maxFileSize10Mb: "מקסימום: 10MB", // translated
  supportedFileTypes: "סוגי קבצים נתמכים:", // translated
  showPassword: "הצג סיסמה", // translated
  hidePassword: "הסתר סיסמה", // translated
  notAvailable: "לא זמין", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "לדוגמה +972501234567", // translated
  websiteUrlPlaceholder: "http://www.example.com", // translated
  loading: "טוען...", // translated
  uploadingDocument: "מעלה מסמך...", // translated
  percentUploaded: "{{percent}}% הועלה", // translated
  registrationSuccessful: "ההרשמה הצליחה.", // translated
  failedToUploadDocument: "העלאת המסמך נכשלה.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} חייב להיות ארוך מ-{{min}} תווים", // translated
  fieldMustBeValidEmail: "{{field}} חייב להיות אימייל תקין", // translated
  fieldPasswordMinLength: "{{field}} חייב להכיל לפחות 8 תווים", // translated
  fieldPasswordRequiresDigit: "{{field}} חייב להכיל לפחות ספרה אחת", // translated
  fieldPasswordRequiresLowercase: "{{field}} חייב להכיל לפחות אות קטנה אחת", // translated
  fieldPasswordRequiresUppercase: "{{field}} חייב להכיל לפחות אות גדולה אחת", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} חייב להכיל לפחות תו מיוחד אחד (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} אינו תואם ל-{{otherField}}", // translated
  fieldBetweenLength: "{{field}} חייב להיות בין {{min}} ל-{{max}} תווים", // translated
  postalCodeBetweenLength: "{{field}} חייב להיות בין {{min}} ל-{{max}} תווים", // translated
  invalidUrlFormat: "פורמט כתובת לא חוקי", // translated
  invalidEmailFormat: "פורמט אימייל לא חוקי", // translated
  emailMustMatchUsername: "האימייל חייב להיות זהה לשם המשתמש (אימייל)", // translated
  mobilePhoneIsRequired: "טלפון נייד הוא שדה חובה", // translated
  certificateFileTooLarge: "קובץ תעודת ההתאגדות גדול מדי", // translated
  termsMustBeAccepted: "יש לאשר את התנאים וההגבלות", // translated
};


export default register;
